import { Component, OnInit } from '@angular/core';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-vision-and-mission',
  templateUrl: './vision-and-mission.component.html',
  styleUrls: ['./vision-and-mission.component.css']
})
export class VisionAndMissionComponent implements OnInit {

  faCheckCircle = faCheckCircle;
  constructor() { }

  ngOnInit(): void {
  }

}
